'use client';

import { REGISTER_COPY } from '@eliadmin/core/src/components/dlz/auth/register/register-copy';
import { RegisterCard } from '@eliadmin/core/src/components/dlz/auth/register/register-card';
import { TextField } from '@eliadmin/core/src/components/dlz/auth/register/register-fields';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Figma „Kontaktná osoba“ (60260:30323): the person of the company – becomes the customer’s name. */
export function ContactCard() {
  const { t } = useTranslations();

  return (
    <RegisterCard title={REGISTER_COPY.contact.title} spacing="compact">
      <div className="grid items-start gap-4 md:grid-cols-2">
        <TextField
          name="name"
          label={t('text33')}
          required
          autoComplete="given-name"
          placeholder={t('text33')}
        />
        <TextField
          name="surname"
          label={t('text34')}
          required
          autoComplete="family-name"
          placeholder={t('text34')}
        />
        <TextField
          name="contact_email"
          type="email"
          inputMode="email"
          autoComplete="email"
          label={t('text35')}
          required
          hint={REGISTER_COPY.contact.emailHint}
          placeholder={REGISTER_COPY.credentials.emailPlaceholder}
        />
        <TextField
          name="phone"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
          label={t('text36')}
          required
          hint={REGISTER_COPY.personal.phoneHint}
          placeholder={REGISTER_COPY.personal.phonePlaceholder}
        />
      </div>
    </RegisterCard>
  );
}
